import RootStore  from 'mobx-stores/root-store'
import { TriggerSearchFunc, StatisticsTableBase } from 'mobx-stores/utils'

export class StatisticsTableStore extends StatisticsTableBase {
  private rootStore:any

  constructor (rootStore:any) {
    super(rootStore)
    this.rootStore = rootStore
  }

  // METHODS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    if (!this.storeId) return
    const data = await this.rootStore.generalStore.api.statisticsApi.getStoreStatistics(
      this.storeId,
      this.productFilter,
      { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
    )
    this.handleSearchResult(data as any)
  }

  // COMPUTED
  private get storeId (): number {
    return this.rootStore.userStore.effectiveStoreId
  }
}
